module.exports = {"361123002":"冰溪街道","361123003":"文成街道","361123101":"临湖镇","361123102":"必姆镇","361123103":"横街镇","361123105":"下镇镇","361123107":"岩瑞镇","361123108":"双明镇","361123109":"紫湖镇","361123110":"仙岩镇","361123111":"樟村镇","361123112":"枫林镇","361123200":"南山乡","361123201":"怀玉乡","361123202":"下塘乡","361123203":"四股桥乡","361123204":"六都乡","361123290":"三清乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361123.json
// module id = 1457
// module chunks = 0